import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Divider, Flex, Paper, Stack, Text } from "@mantine/core";
import { IconChevronRight, IconEyeOff } from "@tabler/icons-react";

import { CampaignItem } from "./CampaignItem";

export const CampaignsInSignup = () => {
    const { t } = useTranslation(["common"]);
    const navigate = useNavigate();
    const campaignsInSignup = [
        {
            id: "1",
            name: "Skleněná lahev Philips Avent Natural Response proti kolice",
            image: "https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/images/bg-7.png",
            dateFrom: "24. 7. 2022",
            dateTo: "27. 7. 2022",
            candidates: 5,
            comments: 3,
        },
        {
            id: "2",
            name: "Skleněná lahev Philips Avent Natural Response proti kolice",
            dateFrom: "24. 7. 2022",
            dateTo: "27. 7. 2022",
            candidates: 5,
            comments: 3,
        },
    ];
    return (
        <Paper p={28} radius={12}>
            <Text mb={24} weight={600}>
                {t("dashboard_in_progress_signup")}
            </Text>
            <Stack spacing={16}>
                {campaignsInSignup.map((campaign, index) => (
                    <>
                        {index > 0 && <Divider color="#EEEFF2" />}
                        <CampaignItem {...campaign} />
                    </>
                ))}
                {campaignsInSignup.length === 0 && (
                    <Flex
                        px={12}
                        py={8}
                        gap={8}
                        align="center"
                        style={{
                            backgroundColor: "#e2f8ff",
                            borderRadius: 12,
                            cursor: "pointer",
                        }}
                        onClick={() =>
                            navigate("/campaigns")}
                    >
                        <IconEyeOff size={26} color="#30A9D4" />
                        <Text
                            size={18}
                            weight={700}
                            color="#30A9D4"
                            style={{ lineHeight: 1.2 }}
                        >
                            {t("dashboard_in_progress_join_testing")}
                        </Text>
                        <IconChevronRight
                            size={18}
                            stroke={3}
                            color="#30A9D4"
                            style={{ marginLeft: "auto" }}
                        />
                    </Flex>
                )}
            </Stack>
        </Paper>
    );
};
